import React, { Component } from 'react';
import '../css/App.css';
import API from '../config_api'
import axios from 'axios'
import Sidenav from './Sidenav';
import FormInput from '../component/FormInput';
import IdleTimerLogout from './IdleTimerLogout';
import Footer from '../component/Footer';
import { Tabs, Tab } from 'react-bootstrap';
import moment from 'moment';
import { handleApiError } from '../utils/errorHandler';
import PatientSafetyCertificate from '../component/PatientSafetyCertificate';

const isPatientSafetyCertificate = (name) => {
    if (!name) return false;
    const lower = String(name).toLowerCase();
    return lower.includes('patient safety') || lower.includes('international patient safety');
};
class Cerificate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            activeTab: 'online',

            onlineData: [],
            offlineData: [],
            loading: false,// Set default active tab
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

  

    componentWillMount() {
        if (!localStorage.getItem('token')) {
            this.props.history.push('/')
        }
        this.fetchData('online');
    }
    btnAction(data) {
        this.props.history.push('/overview', { data })
    }
    handleSubmit(event) {
        event.preventDefault();
        let formData = new FormData();
        formData.append('token_id', localStorage.getItem('token'))
        formData.append('program_search_key', event.target[0].value)
        axios({
            method: 'post',
            url: API.SearchUnit,
            data: formData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            mode: 'no-cors',
        })
            .then(res => {
                if (res.data.status === 'success') {
                    this.setState({ data: res.data.data })
                }
                else {
                    alert(res.data.message)
                }
            });

    }

    handleTabChange(tab) {
        this.setState({ activeTab: tab }, () => {
            this.fetchData(tab); // Fetch data when the tab is changed
        });
    }

    fetchData(tab) {
        this.setState({ loading: true });

        const apiUrl =
            tab === 'online'
                ? 'https://koach.kauveryhospital.com/webservice/certificate_pdf'
                : 'https://koach.kauveryhospital.com/webservice/offline_certificate_pdf';

        // Create a FormData object and append the token
        const formData = new FormData();
        formData.append('token_id', localStorage.getItem('token'));

        axios
            .post(apiUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.data.status === 'success') {
                    if (tab === 'online') {
                        this.setState({ onlineData: response.data.data });
                    } else {
                        this.setState({ offlineData: response.data.data });
                    }
                } else {
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                handleApiError(error);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    render() {
        const { activeTab, onlineData, offlineData, loading } = this.state;
        return (
            <div className="">

                {/* <Sidenav type={'second'} url={'/dashboard'}/> */}
                <nav class="navbar navbar-top navbar-expand navbar-dark  border-bottom" style={{
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    top: 0,
                    zIndex: 1
                }}>
                    <div class="container pad_z">
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <div className="col-sm-3 pad_z ">
                                <i className="material-icons back-btn grey-text" onClick={() => this.props.history.push('/dashboard')}>arrow_back</i>
                            </div>
                            <div className="col-sm-6 text-center pad_z" style={{ fontSize: 20 }}> Cerificate</div>
                            <div className="col-sm-3 text-right  pad_z vertical-align justify-content-end"></div>

                        </div>
                    </div>
                </nav>

                <div className="container">
                    <div style={{ position: 'fixed', left: 0, right: 0, zIndex: 1, background: '#F8F9FE' }}>
                        <div className="container">
                            <div className="row">


                            </div>
                        </div>
                    </div>
                    <div style={{ height: 60 }}></div>

                    <div className='mt-3'>
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(key) => this.handleTabChange(key)}
                            className="mb-3"
                        >
                            <Tab eventKey="online" title="Online">
                                <div className="tab-content">
                                    {loading ? (
                                        <p>Loading online certificates...</p>
                                    ) : (
                                        <div className='d-flex align-items-center justify-content-center mt-4 mb-4 flex-column'>
                                            {onlineData.map((item, i) => (
                                                isPatientSafetyCertificate(item.certificate) ? (
                                                    <div key={i} style={{ position: 'relative', width: '100%', maxWidth: '900px' }}>
                                                        <PatientSafetyCertificate 
                                                            user={item.user} 
                                                            date={moment(item.date).isValid() ? moment(item.date).format('DD-MM-YYYY') : item.date} 
                                                        />
                                                    </div>
                                                ) : (
                                                    <div key={i} style={{ position: 'relative' }}>
                                                        {/* <i
                                                            style={{ position: 'absolute', right: '-86px', cursor: 'pointer' }}
                                                            className="fa fa-download fa-4x"
                                                            // onClick={() => generatePdf(uniqueId, `${item.certificate}`)}
                                                        ></i> */}
                                                        <div className="certificate-container">
                                                            <div className="certificate-content">
                                                                <div className=''>
                                                                    <div className="certificate-header ">

                                                                        <img
                                                                            src={require('../images/logo.jpeg')}
                                                                            alt="Koach"
                                                                            className="koachlogo"
                                                                        />
                                                                        <img src={require("../images/logo-k.png")} alt='test'
                                                                            style={{ height: 80 }} />

                                                                    </div>
                                                                    <h1 className="certificate-title mb-5 mt-4">{item.certificate}</h1>
                                                                    <p className="certificate-subtitle mb-5">Online training program course completion certificate</p>
                                                                    <div className="certificate-body">
                                                                        <p>
                                                                            This is to certify that <span className="highlight"><b>{item.user}</b></span> has <br /> successfully completed <br /> "{item.certificate}" <br /> online training program on <span className="highlight"><b>{moment(item.date).format('DD-MM-YYYY')}</b></span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="certificate-footer">
                                                                    <em>Note: This is a computer-generated certificate and does not require any seal/signature in original</em>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </Tab>
                            <Tab eventKey="offline" title="Offline">
                                <div className="tab-content">
                                    {loading ? (
                                        <p>Loading offline certificates...</p>
                                    ) : (
                                        <div className='d-flex align-items-center justify-content-center mt-4 mb-4 flex-column'>
                                        {offlineData.map((item, i) => (
                                            isPatientSafetyCertificate(item.certificate) ? (
                                                <div key={i} style={{ position: 'relative', width: '100%', maxWidth: '900px' }}>
                                                    <PatientSafetyCertificate 
                                                        user={item.user} 
                                                        date={item.date} 
                                                    />
                                                </div>
                                            ) : (
                                                <div key={i} style={{ position: 'relative' }}>
                                                    {/* <i
                                                        style={{ position: 'absolute', right: '-86px', cursor: 'pointer' }}
                                                        className="fa fa-download fa-4x"
                                                        // onClick={() => generatePdf(uniqueId, `${item.certificate}`)}
                                                    ></i> */}
                                                    <div className="certificate-container">
                                                        <div className="certificate-content">
                                                            <div className=''>
                                                                <div className="certificate-header ">

                                                                    <img
                                                                        src={require('../images/logo.jpeg')}
                                                                        alt="Koach"
                                                                        className="koachlogo"
                                                                    />
                                                                    <img src={require("../images/logo-k.png")} alt='test'
                                                                        style={{ height: 80 }} />

                                                                </div>
                                                                <h1 className="certificate-title mb-5 mt-4">{item.certificate}</h1>
                                                                <p className="certificate-subtitle mb-5">Classroom training program course completion certificate</p>
                                                                <div className="certificate-body">
                                                                    <p>
                                                                        This is to certify that <span className="highlight"><b>{item.user}</b></span> has <br /> successfully completed <br /> "{item.certificate}" <br /> classroom training program on <span className="highlight"><b>{item.date}</b></span>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="certificate-footer">
                                                                <em>Note: This is a computer-generated certificate and does not require any seal/signature in original</em>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                    )}
                                </div>
                            </Tab>
                        </Tabs>
                    </div>

                </div>
                <Footer page="search" Push={this.props.history} />
            </div>
        )
    }
}
export default Cerificate;